<script setup lang="ts">
interface Props {
    label: string;
    // biome-ignore lint/suspicious/noExplicitAny: Init Biome
    value: any;
}

defineProps<Props>();
</script>
<template>
    <div class="FormView">
        <div class="FormView-label" v-html="label"></div>
        <div class="FormView-value">{{ value }}</div>
    </div>
</template>
<style lang="scss">
.FormView {
    &-label {
        color: $black;
        margin-bottom: calc($padding / 3);
    }
    &-value {
        color: $black;
    }
}
</style>
